import React from 'react';
import InvoicesTable from '../InvoicesTable';

export default function InvoicesIndexPage() {
	return <InvoicesTable handleQueryParams enableViews enableMultiSelect enableMessaging />;
}
